module.exports = __webpack_public_path__ + "img/icon_pay_way_active.38fb2a74.png";